/**
 * useShellGround - THE ONE SEAM between the rules and the map.
 *
 * Every rule that would ask the battlefield a question - range and cover
 * between two people, what the ground does to someone, who an area attack
 * catches, auras, kill zones, the actor's reach - is handed `ruleTokens`,
 * never the raw markers. While positions count, that IS the markers. While
 * they do not (the GM's switch, off by default in Narrative; on in Stealth since 2026-11-01),
 * it is an empty record, and each of those rules answers as it always has
 * for a session with nobody on the map: range and cover are set by hand,
 * line of sight is not checked, and an area attack asks who it caught.
 *
 * The markers themselves are untouched: the map still draws them, arrivals
 * are still placed, scenes, deployment, rooms, import/export and pings still
 * read them. `src/test/architecture/positionsSeam.test.ts` holds the line.
 *
 * @param {Record<string, object>} tokens - the battlefield's markers
 * @param {import('../engine/phase/types').PhaseFrame | null} frame - null while unknown: Combat's default
 * @returns {{ positionsCount: boolean, ruleTokens: Record<string, object> }}
 */
import { useMemo } from 'react';
import { positionsCount } from '../engine/phase/layout';
import { emptyFrame } from '../engine/phase/frame';

/** One identity for "nobody is anywhere", so memos keyed on the tokens hold. */
const NO_TOKENS = Object.freeze({});
const NO_FRAME = emptyFrame();

export default function useShellGround(tokens, frame) {
  const counts = positionsCount(frame ?? NO_FRAME);
  // Keyed on what is HANDED OUT: with positions off, a marker moving underneath changes nothing here.
  const ruleTokens = counts ? tokens : NO_TOKENS;
  return useMemo(() => ({ positionsCount: counts, ruleTokens }), [counts, ruleTokens]);
}
